<template>
<div class="container-fluid">
	<page-loading v-if="!data_loaded" />

	<div v-else class="row">
	    <div class="col-12">
			<h1>Trashed Physicians</h1>
		</div>
		<div class="col-12">
			<div class="card table-responsive">
    			<table class="physicians-table table mb-0">
    				<thead>
    					<th></th>
    					<th>Client</th>
    					<th>Physician</th>
    					<th>User</th>
    					<th>Deleted</th>
    					<th></th>
    				</thead>

    				<tr v-for="physician in physicians">
    					<td>
    						<input type="checkbox" :value="physician.id" v-model="ids">
    					</td>
    					<td>
    						<span v-html="physician.client ? physician.client.name : '<em>unknown client</em>'" />
    					</td>
    					<td>
							<span v-html="physician.display_name" />
    					</td>
    					<td>
    						<span v-html="physician.user ? physician.user.display_name : '<em>unknown or none</em>'" class="text-gray-700" />
    					</td>
    					<td>
    						<span v-html="moment(physician.deleted_at).format('MMM D, YYYY')" class="text-gray-500" />
    					</td>
    					<td>
    						<button class="btn btn-light btn-sm" v-tooltip.bottom="'Put Back'" @click="restoreItems(physician.id)"><i class="fal fa-trash-undo text-gray-500"></i></button>
    						<button class="btn btn-light btn-sm" v-tooltip.bottom="'Permadelete'" @click="deleteItems(physician.id)"><i class="fal fa-times-circle text-gray-500"></i></button>
    					</td>
    				</tr>

    				<tr>
    					<td>
    						<input type="checkbox" @click="toggleAll()">
    					</td>
    					<td colspan="5">
    						<button class="btn btn-primary" :disabled="ids.length < 1" @click="restoreItems()"><i class="fal fa-trash-undo mr-1"></i>Restore Items</button>
    						<button class="btn btn-primary" :disabled="ids.length < 1" @click="deleteItems()"><i class="fal fa-times-circle mr-1"></i>Permanently Delete</button>
    					</td>
    				</tr>
    			</table>
    		</div>
        </div>
    </div>
</div>	

</template>

<script>
	import BreadcrumbsManager from '../../../helpers/BreadcrumbManager';

	export default {
		mixins: [BreadcrumbsManager],

		data() {
			return {
				data_loaded: false,
				physicians: null,

				ids: [],
			}
		},

		created() {
			this.fetchTrashedPhysicians();
		},

		activated() {
			this.setBreadcrumbs([
	            { text: 'Home', to: { name: 'home' } },
	            { text: 'Trashed Items', to: { name: 'admin.trashed.physicians'} },
	            { text: 'Physicians', to: { name: ''} },
        	]);
		},


		methods: {
			deleteItems(id) {
				let ids = id ? [id] : this.ids;
				Swal.fire({
					title: 'Are you sure?',
					text: 'You will *really* not be able to recover the item(s)',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonText: 'Delete',
					cancelButtonText: 'Keep',
					animation: false,
				}).then((result) => {
					if (result.value) {
						this.data_loaded = false;
						axios.post('/api/physicians/trashed/delete', { ids: ids }).then(({data}) => {
							Swal.fire({
			                    toast: true,
			                    position: 'top-end',
			                    showConfirmButton: false,
			                    timer: 3000,
			                    icon: 'success',
			                    title: 'Items deleted',
			                });
			                this.fetchTrashedPhysicians();					
						});
					}
				});
			},

			fetchTrashedPhysicians() {
				axios.get('/api/physicians/trashed').then(({data}) => {
					this.physicians = data;
					this.data_loaded = true;
				})
			},

			restoreItems(id) {
				let ids = id ? [id] : this.ids;
				this.data_loaded = false;
				axios.post('/api/physicians/trashed/restore', { ids: ids }).then(({data}) => {
					Swal.fire({
	                    toast: true,
	                    position: 'top-end',
	                    showConfirmButton: false,
	                    timer: 3000,
	                    icon: 'success',
	                    title: 'Items restored',
	                });
	                this.fetchTrashedPhysicians();					
				});
			},

			toggleAll() {
				if (this.ids.length > 0) {
					this.ids = [];
				} else {
					this.ids = this.physicians.map(physician => physician.id);
				}
			}
		},
	}
</script>